import keyMirror from 'react/lib/keyMirror';

const Actions = keyMirror({

  LOAD_WEBSITE_SUCCESS: null,
  LOAD_SERVICE_SUCCESS: null,
  LOAD_PRODUCT_SUCCESS: null,
  LOAD_HOMEWEBSITE_SUCCESS: null,
  LOAD_HOMESERVICE_SUCCESS: null,
  LOAD_HOMEPRODUCT_SUCCESS: null,
  LOAD_INTL_SERVER: null,
  LOGIN_SERVICE_SUCCESS: null,
  LOAD_SERVICEMORE_SUCCESS: null,
  LOAD_PRODUCTMORE_SUCCESS: null,
  LOAD_WEBSITEMORE_SUCCESS: null,
  LOGOUT_SUCCESS: null,
  LOAD_ENTITYSERVICE_SUCCESS: null,
  LOAD_ENTITYWEBSITE_SUCCESS: null,
  LOAD_ENTITYPRODUCT_SUCCESS: null,
  LOAD_HOMETRENDING_SUCCESS: null,
  LOAD_CATEGTRENDING_SUCCESS: null,
  LOAD_SERVICETRENDING_SUCCESS: null,
  LOAD_PROFILE_SUCCESS: null,
  LOAD_POPULARTOPICS_SUCCESS: null,
  LOAD_AUTOCOMPLETESERVICE_SUCCESS: null,
  LOAD_USERFAVOURITE_SUCCESS: null,
  UPDATE_FEEDBACK_USERFAVOURITE_ENTERTAINER_SUCCESS: null,
  LOAD_USERFAVOURITE_ENTERTAINER_SUCCESS: null,
  // fluxible-router actions
  CHECK_USER_SUCCESS: null,
  REGISTER_USER_SUCCESS: null,
  SESSION_CHECK_SUCCESS: null,
  SESSION_CREATE_SUCCESS: null,
  SESSION_UPDATE_SUCCESS: null,
  NAVIGATE_START: null,
  NAVIGATE_SUCCESS: null,
  NAVIGATE_FAILURE: null,
  UPDATE_FEEDBACK_USERFAVOURITE_SUCCESS: null,
  REFRESH_USERFAVOURITE: null,
  LOAD_USERFEEDBACK_SUCCESS: null,
  LOAD_RESULTS_SUCCESS: null,
  LOAD_OFFERS_SUCCESS: null
});


export default Actions;



// WEBPACK FOOTER //
// ./src/constants/Actions.js